import SVG from 'react-inlinesvg'
import { useEnv } from '../../utils/useEnv'
import { useContextScreensaver } from '../../contexts/screensaverContext'

const BrandLogo = () => {
  const { isWeb } = useEnv()
  const { setIsScreensaverOn } = useContextScreensaver()

  return isWeb ? (
    <a
      className="fixed bottom-0 right-0 z-[2] flex rounded-tl-[20px] border-0 bg-white px-[12px] py-[9px] text-center font-approach-medium shadow-floating md:rounded-tl-[24px] md:px-[15px] md:py-[10px] xl:rounded-tl-[39px] xl:px-[22.5px] xl:py-[17.5px] xxl:bottom-[6vh] xxl:right-[3vw] xxl:w-[220px] xxl:rounded-[17px]"
      onClick={() => setIsScreensaverOn(false)}
      href="https://www.neprajz.hu/"
      target="_blank"
      rel="noreferrer"
    >
      <SVG className="h-[20px] md:h-[25px] xl:h-[35px]" src="/images/brandlogo.svg" />
    </a>
  ) : null
}

export default BrandLogo
